 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      <div>{{ titleName }}</div>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12 v-if="actionName === 'policyNo'">
                          <v-text-field
                            v-on:keydown.enter.prevent="doPolicyFilters"
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.policyNo"
                            :label="filtersPolicyLabel.policyNo"
                            :error-messages="errors.collect('policyNo')"
                            data-vv-name="policyNo"
                            :data-vv-as="filtersPolicyLabel.policy"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12 v-if="actionName === 'branch'">
                          <v-text-field
                            v-on:keydown.enter.prevent="doPolicyFilters"
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.branch"
                            :label="filtersPolicyLabel.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="filtersPolicyLabel.branch"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12 v-if="actionName === 'documentNo'">
                          <v-text-field
                            v-on:keydown.enter.prevent="doPolicyFilters"
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.documentNo"
                            :label="filtersPolicyLabel.documentNo"
                            :error-messages="errors.collect('documentNo')"
                            data-vv-name="documentNo"
                            :data-vv-as="filtersPolicyLabel.documentNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="actionName === 'policyNo'">
        <v-data-table
          :headers="polNoHeaders"
          :items="acctPolicyItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.policyNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.endtCnt }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 class="mt-2" v-if="actionName === 'branch'">
        <v-data-table
          :headers="polBranchHeaders"
          :items="acctPolicyItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.branch }}</td>
              <td>{{ row.item.branchDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBranch(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 class="mt-2" v-if="actionName === 'documentNo'">
        <v-data-table
          :headers="polDocNoHeaders"
          :items="acctPolicyItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignDocumentNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      titleName: null,
      filtersPolicyLabel: {
        policyNo: 'Policy',
        branch: 'Branch',
        documentNo: 'Document No.'
      },
      filtersPolicy: {
        policyNo: undefined,
        accountNo: undefined,
        branch: undefined,
        documentNo: undefined,
        actionName: undefined
      },
      acctPolicyItems: [],
      totalItemsPol: 0,
      polNoHeaders: [
        { text: 'Policy No.', align: 'left', value: 'policyNo' },
        { text: 'Ren Count', align: 'left', value: 'renCnt' },
        { text: 'Endt Count', align: 'left', value: 'endtCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      polBranchHeaders: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Description', align: 'left', value: 'branchDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      polDocNoHeaders: [
        { text: 'Document No.', align: 'left', value: 'docNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationPolicy': function (value) {
      this.fetchAcctPolicyData2()
    },
    boolRefresh: function (value) {
      if (value) {
        this.doClearPolicyFilters()
      }
    }
  },
  mounted() {
    this.doClearPolicyFilters()
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.policyNo = ''
      this.filtersPolicy.branch = ''
      this.filtersPolicy.documentNo = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      if (this.actionName === 'policyNo') {
        this.titleName = 'Account Policy'
      } else if (this.actionName === 'branch') {
        this.titleName = 'Account Branch'
      } else if (this.actionName === 'documentNo') {
        this.titleName = 'Account Document No.'
      }
      this.filtersPolicy.policyNo = ''
      this.filtersPolicy.branch = ''
      this.filtersPolicy.documentNo = ''
      this.filtersPolicy.accountNo = this.acctNo
      this.filtersPolicy.actionName = this.actionName
      this.fetchAcctPolicyData2()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          this.paginationPolicy.page = 1
          this.filtersPolicy.accountNo = this.acctNo
          this.filtersPolicy.actionName = this.actionName
          this.fetchAcctPolicyData2()
        }
      })
    },
    assignPolicy(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-acctData', data.policyNo, this.actionName)
      this.$emit('close')
    },
    assignBranch(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-acctData', data.branch, this.actionName)
      this.$emit('close')
    },
    assignDocumentNo(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-acctData', data.docNo, this.actionName)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    acctNo: {
      type: String,
      default: ''
    },
    actionName: {
      type: String,
      default: ''
    },
    boolRefresh: {
      type: Boolean,
      default: false
    }
  }
}
</script>
